import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { Desktop, Mobile } from 'app/components/Responsive';
import OpenBasketButtonMobile, { DesktopOpenBasketButton } from 'app/components/OpenBasketButton';

import { ConfigContext } from '../ConfigProvider';
import { FiltersContext } from '../FiltersProvider';
import { isHalloweenPages } from '../OrderDetails/OrderDetailsBoxes/components/BoxesCheckForm';


const BUTTON_TYPE_SCROLL = 'scrollToCheckout';
const BUTTON_TYPE_BASKET_LINK = 'linkToBasket';
const BUTTON_TYPE_CHECKOUT_LINK = 'linkToCheckout';

const BUTON_TYPES_RECORD = {
    [BUTTON_TYPE_SCROLL]: {
        elType: 'button',
        path: null,
    },
    [BUTTON_TYPE_BASKET_LINK]: {
        elType: 'a',
        path: '/basket/',
    },
    [BUTTON_TYPE_CHECKOUT_LINK]: {
        elType: 'a',
        path: '/checkout/',
    },
};

const getSpecificLinkParams = (pageId) => {
    switch (pageId) {
        case 'grn':
            return { hide: 'payment_button_recurrent' };
        case 'evrd':
            return { menu: 'everyday', cm: '10', hide: 'payment_button_recurrent' };
        default:
            return {};
    }
};

export default function OpenBasketButton(props) {
    const {
        originalPrice,
        priceValue,
        promocodeConditions,
        onClick,
        title,
        position,
    } = props;

    const { period } = useContext(FiltersContext);

    const {
        openBasketButtonType,
        pageId,
    } = useContext(ConfigContext);

    const specificParams = getSpecificLinkParams(pageId);

    const buttonType = Object.keys(BUTON_TYPES_RECORD).includes(openBasketButtonType)
        ? openBasketButtonType
        : BUTTON_TYPE_SCROLL;
    const { elType, path } = BUTON_TYPES_RECORD[buttonType];

    const { search } = window.location;
    const params = queryString.parse(search);

    const linkSearch = queryString.stringify({
        ...params,
        period,
        payment: 'online',
        ...specificParams,
    });

    const isHlwnPage = isHalloweenPages(pageId);

    const href = buttonType === BUTTON_TYPE_SCROLL ? null : `${path}?${linkSearch}`;
    const currentTitle = title || 'Оформить заказ';

    return (
        <>
            <Mobile isWideMobile>
                <OpenBasketButtonMobile
                    position={position || 'relative'}
                    price={priceValue}
                    originalPrice={originalPrice}
                    onClick={onClick}
                    promocodeConditions={promocodeConditions}
                    elType={elType}
                    href={href}
                    title={currentTitle}
                    rowPriceOnly={isHlwnPage}
                />
            </Mobile>
            <Desktop isWideMobile>
                <DesktopOpenBasketButton
                    price={priceValue}
                    originalPrice={originalPrice}
                    onClick={onClick}
                    elType={elType}
                    href={href}
                    title={currentTitle}
                    rowPriceOnly={isHlwnPage}
                />
            </Desktop>
        </>
    );
}

OpenBasketButton.propTypes = {
    originalPrice: PropTypes.number.isRequired,
    priceValue: PropTypes.number.isRequired,
    promocodeConditions: PropTypes.shape({}).isRequired,
    onClick: PropTypes.func.isRequired,
};
